export default "__VITE_ASSET__7TCfVRvt__"